module.exports = __webpack_public_path__ + "static/media/BigScienceMatchIcon.855984d5.svg";